import { Injectable } from '@angular/core';
import {ITreatment, ITreatmentDetails} from '@interfaces/ITreatment';
import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {MainService} from './main.service';
import IFilter from '@interfaces/IFilter';
import IOrder from '@interfaces/IOrder';

@Injectable({
  providedIn: 'root'
})
export class TreatmentService extends MainService {
  listUrl = '/treatments';
  detailsUrl = '/treatments';

  constructor( protected http: HttpClient ) {
    super( http );
  }

  getList(filters?: IFilter[], orders?: IOrder[], limit?: number, page?: number): Observable<ITreatment[]> {
    if ( !orders ) {
      orders = this.setDefaultOrder();
    }

    return super.getList( filters, orders, limit, page );
  }

  getListExtended(filters?: IFilter[], orders?: IOrder[], limit?: number, page?: number): Observable<HttpResponse<ITreatment[]>> {
    if ( !orders ) {
      orders = this.setDefaultOrder();
    }

    return super.getList( filters, orders, limit, page, true );
  }

  getDetails( slug: string ): Observable<ITreatmentDetails> {
    return super.getDetails( slug );
  }

  private setDefaultOrder(): IOrder[] {
    const orders: IOrder[] = [];

    orders.push({
      field: 'isSingledOut',
      type: 'DESC'
    });

    orders.push({
      field: 'name',
      type: 'ASC'
    });

    return orders;
  }
}
